import Highcharts from 'highcharts';
import highchartsAccessibility from 'highcharts/modules/accessibility'
highchartsAccessibility(Highcharts)
import highchartsExporting from 'highcharts/modules/exporting';
highchartsExporting(Highcharts);
import highchartsExportData from 'highcharts/modules/export-data';
highchartsExportData(Highcharts);

const nodata = require('highcharts/modules/no-data-to-display');
nodata(Highcharts);
const template = document.createElement('template');
template.innerHTML = ``
const baseTemplate = `
<style>
  #highchartsContainer {
    height: 650px;
  }
 
  #highchartsContainer .highcharts-plot-line {
    fill: none;
    stroke: #333333;
    stroke-width: 1px;
  }
</style>
<div id="highchartsContainer"></div>
`;

export default class HighchartsComponentBase extends HTMLElement {
  constructor(childTemplate) {
    super();
    template.innerHTML = childTemplate + baseTemplate; //baseTemplate.innerHTML += childTemplate;
    this._shadowRoot = this.attachShadow({ 'mode': 'open' });
    this._shadowRoot.appendChild(template.content.cloneNode(true));
    this.target = this.shadowRoot.querySelector("#highchartsContainer");
    this.series = [];
    this.categories = [];

  }

  setChartOptions(chartObj) {
    this.chartOptions = {};
    //this.chartOptions = { ...Highcharts.defaultOptions, ...chartObj }
    Object.assign(this.chartOptions, Highcharts.defaultOptions, chartObj);
  }
  render(titleText) {

    if (this.chart != undefined) {
      this.chart.hideLoading();
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(false, false);
      } 
      this.series.forEach((serie) => {
        this.chart.addSeries(serie, false);
      });
      this.chart.redraw();
    } else {
      //this.chartOptions.series = [...this.series];
      //this.chartOptions.series = {};
      this.chartOptions.series = Object.assign(this.series);
      this.chart = new Highcharts.Chart(this.target, this.chartOptions);
    }
    this.series.length = 0;
    this.chart.setTitle(null, { text: titleText });

  }

  getShadow() {
    return this._shadowRoot;
  }

  showLoading() {
    if (this.chart != undefined) {
      this.chart.showLoading();
    }
  }

  addSeries(label, seriesData, enabled, color) {
    this.series.push({ name: label, data: seriesData, visible: enabled, zIndex: enabled ? 1 : 0, color: color });
  }
  addUnnamedSerie(seriesData) {
    this.series.push(seriesData);
  }
  addSeriesExtra(label, seriesData, extraData) {
    var serie = {name: label, data: seriesData};
    

    //let merged = {...serie, ...extraData};
    let merged = Object.assign(serie, extraData);
    this.series.push(merged);
  }
  addSerieList() {
    this.series =[];

  }

  addStackedSeries(label, seriesData, stack, color) {
    this.series.push({ name: label, data: seriesData, stack: stack, color: color });
 }

  setSubtitle(titleText) {
    if (this.chart != undefined) {
      this.chart.setTitle(null, { text: titleText });
    }
  }


  errorNoData() {
    if (this.chart != undefined) {
      while (this.chart.series.length > 0) {
        this.chart.series[0].remove(true);
      }
      this.chart.hideLoading();
      this.chart.showNoData("Det finns ingen data att visa för givna sökparametrar");
    }


  }
  connectedCallback() {
   

  }


  /**
   * TODO:
   * Supply template to base component, but keep option to create template in base
   * Don't require base component to know about other elements (such as dropdowns etc), but allow subclass to pass template to use
   * remove unused code
   * do not render more than once. highcharts do have some update method to use instead to update the dataset
   */

}
